export default __webpack_public_path__ + "static/media/edit_veryDarkGrey.3fb02d07.svg";